// extracted by mini-css-extract-plugin
module.exports = {"form_container":"GlobalForm_form_container__Ku_KZ","required_label":"GlobalForm_required_label__2ijnR","divider_above_save":"GlobalForm_divider_above_save__1XBXl"};